<template>

<!--  <router-link :to="cabinetsLink" class="User__nav__resume is&#45;&#45;mobile">
    <div class="inner">
      <span class="profil">compte <strong>{{ profil }}</strong></span>
      <span class="name">{{ firstname }} {{ name }}</span>
      <span v-if="currentCabinet" class="cabinet">
        <Icon name="cabinet-min" />
        <span>{{ currentCabinet }}</span>
      </span>
    </div>
  </router-link>-->

</template>

<script>
import { user } from '@/store/user'
import { useCabinets } from '@/store/cabinets'
import Icon from '@components/Icon'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      profil : user.value.profil,
      firstname : user.value.firstname,
      name : user.value.name,
      currentCabinet : useCabinets.getCurrent() ? useCabinets.getCurrent().name : null,
      cabinetsLink: '/'
    }
  }
}
</script>
